import pkg from '../../package.json' with { type: 'json' };
import type { CommonUIConfig } from './uiConfigTypes';

const coreUrl = typeof window !== 'undefined' ? window.location.origin : 'https://www.fox.com';

export const uiCommonConfig: CommonUIConfig = {
  appName: 'FOX One',
  appPlatform: 'web',
  appVersion: pkg.version,
  authCookieDomain: '.fox.com',
  brazeEndpoint: 'sdk.iad-07.braze.com',
  coreUrl,
  endCardTimer: 10, // seconds
  isLogEnabled: process.env.NEXT_PUBLIC_ENABLE_UI_LOGGING === 'true',
  minimumWatchedPercentageRequiredToRecordBookmarks: 3,
  openMobileAppLink: 'https://foxone.onelink.me/MHYO/HSB1',
  downloadMobileAppLink: 'https://foxone.onelink.me/MHYO/DownloadApp',
};
